import { UserNotificationsQueryDocument as __graphqlDocument0 } from 'store/client/documents/UserNotificationsQueryDocument'; 

export const userNotificationsQuery = __graphqlDocument0







;
